import { Component, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import * as utils from '../utils';
import * as units from '../units';
import * as enums from '../enums';
import * as settings from '../settings';
import { Point } from '../Point';

@Component({
  selector: 'crdt',
  templateUrl: './crdt.component.html',
  styleUrls: ['./crdt.component.scss']
})
export class CrdtComponent {

  @Output() submit: EventEmitter<any> = new EventEmitter<any>();

  form: FormGroup;
  coordinatesType: enums.CoordinateType;
  isLL = false;
  isUTM = false;

  maskCustomPatterns = {
    '0': { pattern: new RegExp(`\\d`) },
    '1': { pattern: new RegExp(`1`) },
    'N': { pattern: new RegExp(`[NnSs]`) },
    'E': { pattern: new RegExp(`[EeWw]`) },
    'Z': { pattern: new RegExp(`[C-H|J-N|P-X|c-h|j-n|p-x]`) },
  }

  maskSpecialCharacters = [units.DEGREE_CHAR, `.`, ` `, `'`, `"`];

  maskLatLL: string;
  maskLongLL: string;
  maskZoneUTM: string;
  maskEastingUTM: string;
  maskNorthingUTM: string;

  constructor(private fb: FormBuilder) {
    this.coordinatesType = settings.userSettings.coordinatesType;
    this.isLL = this.coordinatesType == enums.CoordinateType.WGS84_DMM || this.coordinatesType == enums.CoordinateType.WGS84_DMS;
    this.isUTM = this.coordinatesType == enums.CoordinateType.UTM;

    if (this.coordinatesType == enums.CoordinateType.WGS84_DMM) {
      this.maskLatLL = `N 00.0000${units.DEGREE_CHAR}`;
      this.maskLongLL = `E 100.0000${units.DEGREE_CHAR}||E 00.0000${units.DEGREE_CHAR}`;
    }
    else if (this.coordinatesType == enums.CoordinateType.WGS84_DMS) {
      this.maskLatLL = `N 00${units.DEGREE_CHAR}00'00.0"`;
      this.maskLongLL = `E 100${units.DEGREE_CHAR}00'00.0"||E 00${units.DEGREE_CHAR}00'00.0"`;
    }
    else if (this.coordinatesType == enums.CoordinateType.UTM) {
      this.maskZoneUTM = `00Z`;
      this.maskEastingUTM = `000000`;
      this.maskNorthingUTM = `0||00||000||0000||00000||000000||0000000`;
    }

    this.form = this.fb.group({
      latLL: ['', this.isLL ? Validators.required : undefined],
      longLL: ['', this.isLL ? Validators.required : undefined],
      zoneUTM: ['', this.isUTM ? Validators.required : undefined],
      eastingUTM: ['', this.isUTM ? Validators.required : undefined],
      northingUTM: ['', this.isUTM ? Validators.required : undefined]
    });
  }

  get valid(): boolean {
    return this.form.valid;
  }

  onSubmit() {
    this.submit.emit();
  }

  // Write (x,y) coordinates to the form
  writeForm(coord: Point) {
    let strings = utils.getCoordinatesStrings(coord, this.coordinatesType);
    let defaultLat = '';
    let defaultLong = '';
    let defaultZone = '';
    let defaultEasting = '';
    let defaultNorting = '';

    if (this.isLL) {
      defaultLat = strings[0];
      defaultLong = strings[1];
    }
    else if (this.isUTM) {
      defaultZone = strings[0];
      defaultEasting = strings[1];
      defaultNorting = strings[2];
    }

    this.form.setValue({
      latLL: defaultLat,
      longLL: defaultLong,
      zoneUTM: defaultZone,
      eastingUTM: defaultEasting,
      northingUTM: defaultNorting
    });
  }

  readForm(): Point {
    let strings = [];

    if (this.isLL)
      strings = [this.form.value.latLL, this.form.value.longLL];
    else if (this.isUTM)
      strings = [this.form.value.zoneUTM, this.form.value.eastingUTM, this.form.value.northingUTM];
    
    if (strings.length > 0)
      return utils.getCoordinatesFromStrings(strings.map(string => string.trim()), this.coordinatesType);
    
    return null;
  }

}
